import { render, staticRenderFns } from "./ColorPlane.vue?vue&type=template&id=a6699734&scoped=true&"
import script from "./ColorPlane.vue?vue&type=script&lang=js&"
export * from "./ColorPlane.vue?vue&type=script&lang=js&"
import style0 from "./ColorPlane.vue?vue&type=style&index=0&id=a6699734&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6699734",
  null
  
)

export default component.exports